/**
 * @description 鈑烤產能管理頁面按鈕權限
 * @enum {string} ADD_PROGRESS_BOARD 加入進度看板
 * @enum {string} EDIT 編輯工單
 * @enum {string} INVALID 作廢工單
 */
export enum MaintainStatusBtnPermission {
    ADD_PROGRESS_BOARD = 'AddProgressBoard',
    EDIT = 'secondEdit',
    INVALID = 'Delete'
}

/**
 * @description 工單看板頁面辨別目前打開的ModalInner内容用的keyword
 * @enum {string} MAINTAIN_STATUS 編輯車輛狀態
 * @enum {string} PREDICT_DELIVERY_DATETIME 預計交車時間
 * @enum {string} OPERATION 作廢/完工 工單
 */
export enum MaintainStatusModalInnerType {
    MAINTAIN_STATUS = "maintain_status",
    PREDICT_DELIVERY_DATETIME = "predict_delivery_datetime",
    OPERATION = "operation",
}

/**
 * @description 工單看板頁面辨別目前打開的ModalInner內容用的keyword
 * @enum {string} MODAL_INNER 更新工單資訊Modal
 * @enum {string} MODAL_INNER_SEARCH 進階搜尋篩選條件Modal
 * @enum {string} SEARCH_SETTINGS 篩選設定Modal
 */
export enum MaintainStatusModalName {
    MODAL_INNER = 'modalInner',
    MODAL_INNER_SEARCH = 'modalInnerSearch',
    SEARCH_SETTINGS = 'searchSettings'
}

/**
 * @description 工單狀態
 */
export enum WorkOrderStatus {
    INVALID = "作廢",
    PENDING = "待修",
    STOP = "暫停",
    COMPLETED = "完工",
    CLOSED = "結案"
}

/**
 * @description 工單結束type
 * @enum {string} INVALID 作廢
 * @enum {string} COMPLETED 完工
 */
export enum WorkOrderCloseType {
    INVALID = WorkOrderStatus.INVALID,
    COMPLETED = WorkOrderStatus.COMPLETED,
}

/**
 * @description 車輛維修狀態type
 * @description 選項來自於系統代碼MTS
 * @enum {string} WAITING 待維區
 * @enum {string} REPAIRING 維修區
 * @enum {string} WASHING 洗車區
 * @enum {string} COMPLETED 待交區
 * @enum {string} STOP 暫停區
 */
export enum MaintainStatusType {
    WAITING = "001",
    REPAIRING = "002",
    WASHING = "003",
    COMPLETED = "004",
    STOP = "005"
}